import React, { useState, useEffect } from "react";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { CRow, CCol } from "@coreui/react";
import "./flujo-caja.scss";

const TableHeader = (props) => {
  const theme = useTheme();
  const matches = useMediaQuery("(max-width:1360px)");

  return (
    <div
      className="row py-2 mt-3"
      style={{ fontWeight: "600", fontSize: "16px" }}
    >
      <div className="tw-flex tw-items-center">
        <div className="col-3 pl-4 tw-flex tw-items-center" style={{ minWidth: "180%" }}>
          {props.title}
          {props.button && <div className="tw-ml-4 eerrMargenIcon">{props.button}</div>}
        </div>
        {props.subtitle1 && (
          <div className="col-3">
            <div className="px-2">{props.subtitle1}</div>
          </div>
        )}
        {props.subtitle2 && (
          <div className="col-3">
            <div className="px-2">{props.subtitle2}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TableHeader;
